import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-subscribe-choice',
  templateUrl: './subscribe-choice.component.html',
  styleUrls: ['./subscribe-choice.component.scss']
})
export class SubscribeChoiceComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) { this.site() }
  channelID: string;
  viewMode = 'tab1';
  channel: any = [];
  siteInfo: any = [];
  loaded: boolean = true;
  tag: any;
  myData: any;
  subChannel: boolean;
  siteID = environment.siteID;
  ozowDataBool: boolean = false;
  subSite: boolean;
  bouquetUser: boolean;
  playlists: any = [];
  sliderOptions = { dots: false, navigation: true, nav: false, autoplay: false, loop: false, autoplayTimeout: 2000, autoplayHoverPause: true, lazyLoad: true, responsive: { 0: { items: 1 }, 600: { items: 2 }, 960: { items: 4 }, 1200: { items: 4 } } };
  contents: any;
  content: any;
  playlist: any;
  sitebillingAgent: any;
  siteRenew: any;
  channelbillingAgent: any;
  products: any = [];
  currencySign: any;
  subscriptionStatusId: any;
  subscribeData: any = [];
  profileData: any = [];
  profileID = '';
  ozowData: any = [];
  counter = 0;
  max = 60;
  intervalManage: any;
  tryAgain: boolean = false;
  failed: boolean = false;
   config = {slidesPerView: this.products.length,autoHeight: true, navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }, loop: true,
  breakpoints: {
    // when window width is <= 320px
    320: {
      slidesPerView: this.products.length,
      spaceBetween: 0
    },
    // when window width is <= 480px
    480: {
      slidesPerView: this.products.length,
      spaceBetween: 0
    },
    // when window width is <= 720px
    720: {
      slidesPerView: this.products.length,
      spaceBetween: 0
    },
    // when window width is <= 720px
    1000: {
      slidesPerView: this.products.length,
      spaceBetween: 0
    }
  }
};
  public site() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getSite?siteID='+this.siteID, {
      headers: myheader
    })
      .subscribe(
        data => {
          this.products = data['products'];
          console.log('number of products');
          console.log(this.products.length);
          this.config = {slidesPerView: this.products.length,autoHeight: true, navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }, loop: true,
          breakpoints: {
            // when window width is <= 320px
            320: {
              slidesPerView: this.products.length ,
              spaceBetween: 0
            },
            // when window width is <= 480px
            480: {
              slidesPerView: this.products.length,
              spaceBetween: 0
            },
            // when window width is <= 720px
            720: {
              slidesPerView: this.products.length,
              spaceBetween: 0
            },
            // when window width is <= 720px
            1000: {
              slidesPerView: this.products.length,
              spaceBetween: 0
            }
          }
        };
          this.siteInfo = data;
          this.siteRenew = this.siteInfo.billingFrequency.name;
          if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'DAILY') {
            this.siteRenew = 'يومي';
          }
          else if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'WEEKLY') {
            this.siteRenew = 'أسبوعي';
          }
          else if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'MONTHLY') {
            this.siteRenew = 'شهري';
          }
          if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'DAILY') {
            this.siteRenew = 'Chaque jour';
          }
          else if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'WEEKLY') {
            this.siteRenew = 'Chaque semaine';
          }
          else if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'MONTHLY') {
            this.siteRenew = 'Chaque mois';
          }
          this.currencySign = this.siteInfo.currency.sign;
          if (window.location.href.indexOf("/ar/") > -1) { 
            this.currencySign = this.siteInfo.currency.alternativeSigns.ar;
          }
          else { 
            this.currencySign = this.siteInfo.currency.sign;
          }
        },
        error => {
        }
      );
  }
  goToSubPage(currencySign, billingAgent, id, cost, billingFrequency) { 
    console.log(billingAgent);
    console.log(id);
    console.log(cost);
    console.log(billingFrequency);
    this.router.navigate(['/subscribe/'+billingAgent+'/'+id+'/'+billingFrequency+'/'+currencySign+'/'+cost]);
  }
  ngOnInit() {
  }

}

